// extracted by mini-css-extract-plugin
module.exports = {"label":"OrgCardInfo_label__2ATd-","text":"OrgCardInfo_text__aP85K","cardNumberContainer":"OrgCardInfo_cardNumberContainer__3E3sB"};